var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_section"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{class:_vm.setMainClass(),style:(_vm.mainStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }